import MenuItem from "@mui/material/MenuItem";
import {
  assignShellUIDs,
  resolveProjectTag,
} from "../../../../../../../utils/pvUID";
import Box from "@mui/material/Box";

export const SHELL_COMPONENTS = [
  "2:1 S.E Head (L/B)",
  "Flat Round Head (L/B)",
  "Flat Round Head (R/T)",
  "Flat Rectangular Head (L/B)",
  "Flat Rectangular Head (R/T)",
  "Cylindrical Shell",
  "Conical Shell",
  "2:1 S.E Head (R/T)",
  "Torispherical Head",
  "Spherical Head",
];

export const getColumns = (getValues, isDark, wbsUid) => [
  {
    accessorKey: "UID",
    header: "UID",
    size: 100,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      sx: {
        textAlign: "center",
        cursor: "default",
        padding: 0,
      },
    },
    Cell: ({ row }) => {
      const tag = resolveProjectTag({
        wbsUid,
        tagNo: getValues("tagNo"),
        legacyTag: getValues("TextBox48"),
      });
      const rows = getValues("DataGridView5") || [];
      const computed = assignShellUIDs(rows, tag)[row.index] || "";
      return (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 0,
            textAlign: "center",
            cursor: "default",
          }}
        >
          {row.original.UID || computed || ""}
        </Box>
      );
    },
  },
  {
    accessorKey: "Component",
    header: "Component",
    size: 150,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiEditTextFieldProps: () => ({
      children: SHELL_COMPONENTS.map((Component) => (
        <MenuItem key={Component} value={Component}>
          {Component}
        </MenuItem>
      )),
      select: true,
      sx: {
        "& .MuiSelect-select": {
          textAlign: "center",
          backgroundColor: "transparent !important",
        },
        "&&": { backgroundColor: "transparent !important" },
      },
    }),
  },
  {
    accessorKey: "Diameter",
    header: "Diameter mm",
    Header: (
      <div>
        <div>Diameter</div>
        <div>(mm)</div>
      </div>
    ),
    size: 20,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
  },

  {
    accessorKey: "Material",
    header: "Material",
    size: 70,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiEditTextFieldProps: () => ({
      disabled: true,
      sx: {
        "&&": { backgroundColor: "transparent !important" },
        "& .MuiInputBase-input": {
          padding: "8.5px 8px",
          textAlign: "center",
          color: isDark ? "rgba(255, 255, 255, 0.5)" : "rgba(0,0,0,0.87)",
          WebkitTextFillColor: isDark
            ? "rgba(255, 255, 255, 0.5)"
            : "rgba(0,0,0,0.87)",
        },
        "& .MuiInputBase-root.Mui-disabled": {
          "& .MuiInputBase-input": {
            color: isDark ? "rgba(255, 255, 255, 0.5)" : "rgba(0,0,0,0.87)",
            WebkitTextFillColor: isDark
              ? "rgba(255, 255, 255, 0.5)"
              : "rgba(0,0,0,0.87)",
          },
        },
      },
    }),
  },
  {
    accessorKey: "Can Length",
    header: "Can Length",
    Header: (
      <div>
        <div>Can Length</div>
        <div>(mm)</div>
      </div>
    ),
    size: 15,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Long Seam",
    header: "Long Seam",
    Header: (
      <div>
        <div>Long Seam</div>
        <div>(deg)</div>
      </div>
    ),
    size: 25,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Provided Thk",
    header: "Provided Thk",
    Header: (
      <div>
        <div>Provided Thk</div>
        <div>(mm)</div>
      </div>
    ),
    size: 35,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Weight",
    header: "Weight",
    Header: (
      <div>
        <div>Weight</div>
        <div>(Kg)</div>
      </div>
    ),
    // ~30px text ("15.16" at 0.7rem) + 16px input side padding + borders.
    // Below ~50 the value clips (e.g. "15.1…").
    size: 60,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
];

export const resultColumns = [
  //column definitions...
  {
    accessorKey: "Allowable_Stress",
    header: "Allowable Stress ",
    Header: (
      <div style={{ width: "100px" }}>
        <div>Allowable Stress</div>
        <div>
          (N/mm<sup>2</sup>)
        </div>
      </div>
    ),
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Required_Thickness",
    header: "Required Thickness (mm)",
    Header: (
      <div style={{ width: "70px" }}>
        <div>Reqd. Thk</div>
        <div>(mm)</div>
      </div>
    ),
    size: "60px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "UCS_Curve",
    header: "UCS Curve",
    size: "40px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "MDMT",
    header: "MDMT (DegC)",
    Header: (
      <div>
        <div>MDMT</div>
        <div>(DegC)</div>
      </div>
    ),
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "MAWP",
    header: "MAWP (N/mm^2)",
    Header: (
      <div>
        <div>MAWP</div>
        <div>
          (N/mm<sup>2</sup>)
        </div>
      </div>
    ),
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Hydrotest_Pressure",
    header: "Hydrotest Pr.",
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
];

export const estimationColumns = [
  //column definitions...
  // NOTE: size must be a plain number (px) — MRT ignores "50px" strings and
  // falls back to wide defaults, which caused the horizontal scrollbar.
  // Total (~530px) fits the estimation panel so no x-scroll appears.
  {
    accessorKey: "Circ_Weld_Hours",
    header: "Circ Weld Hours",
    size: 110,
    enableEditing: false,
  },
  {
    accessorKey: "Long_Weld_Hours",
    header: "Long Weld Hours",
    size: 110,
    enableEditing: false,
  },
  {
    accessorKey: "Rolling_Hours",
    header: "Rolling Hours",
    size: 110,
    enableEditing: false,
  },
  {
    accessorKey: "Dishing_Hours",
    header: "Dishing Hours",
    size: 110,
    enableEditing: false,
  },
  {
    accessorKey: "NDT_Cost",
    header: "NDT Cost",
    size: 90,
    type: "number",
  },
];
